import React from 'react'
import BookCard from '../components/BookCard'
import Layout from '../components/Layout'
import { useGetBooksQuery } from '../features/api/apiSlice'
import { useSelector } from 'react-redux'
import FilterAction from '../components/FilterAction'

export default function Home() {
  const { isLoading, data: books, isSuccess } = useGetBooksQuery();
  const { searchKeyword } = useSelector(state => state.filter);
  const { featured } = useSelector(state => state.filter);

  console.log(books)

  return (
    <Layout>
      <main class="py-12 px-6 2xl:px-6 container">
        <div class="order-2 xl:-order-1">
          <FilterAction />
          <div class="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
            {
              isSuccess && books?.length > 0 && books.filter(book => book.featured === featured ? book.featured === featured : !featured)?.filter(book => book.name.toLowerCase().includes(searchKeyword.toLowerCase()))?.map(book => <BookCard key={book.id} book={book} />)
            }
          </div>
        </div>
      </main>
    </Layout>
  )
}
